<template>
  <b-modal id="modal-download-video-history" centered @hide="onHideModal" @shown="onShowModal">
    <template #modal-header="{ close }">
      <div
        class="d-flex justify-content-between align-items-center mc-video-history-new__modal-download-header-wrapper"
      >
        <span class="text-white"> {{ $t('videoHistory.modalVideoDownload.title') }} </span>
        <i class="icon-outline_close text-white" @click="close()" />
      </div>
    </template>
    <div class="mc-video-history-new__modal-download-content-wrapper">
      <div class="mc-video-history-new__modal-download-select-camera-wrapper field-item">
        <label class="modal-download__label">{{
          $t('global.form.select') + ' ' + $t('trackVideo.camera')
        }}</label>
        <div class="mc-video-history-new__modal-download-select-camera-checkbox-wrapper">
          <div v-for="st in statusTextActive?.split(',')" :key="st">
            <McCheckbox
              v-model="mapModelChannelChecked[st]"
              :label="
                $t('trackVideo.camera') +
                ' ' +
                (Number(statusTextActive.split(',').findIndex((c) => Number(c) === Number(st))) + 1)
              "
            />
          </div>
        </div>
      </div>
      <div class="mc-video-history-new__modal-download-timerange field-item">
        <label class="modal-download__label">{{ $t('videoHistory.timeRange') }}</label>
        <div
          v-if="sectionActive === 'timeline'"
          class="mc-video-history-new__modal-download-timerange-input-wrapper"
        >
          <date-picker
            v-model="range.start"
            type="time"
            format="HH:mm:ss"
            value-type="HH:mm:ss"
            :show-second="true"
            :clearable="true"
            placeholder="HH:mm:ss"
          />
          <i class="icon-outline_minus" />
          <date-picker
            v-model="range.end"
            type="time"
            format="HH:mm:ss"
            value-type="HH:mm:ss"
            :show-second="true"
            :clearable="true"
            placeholder="HH:mm:ss"
            :disabled="!range.start"
            :disabled-time="disableEndTime"
          />
        </div>
        <div v-else class="mc-video-history-new__modal-download-range-form-wrapper">
          <div class="mc-video-history-new__modal-download-field-item-radio-wrapper">
            <McRadioButton
              id="list-range"
              key="list-range"
              v-model="downloadType"
              name="downloadType"
              initialValue="list-range"
              :label="$t('videoHistory.rangeList')"
            />
            <Multiselect
              v-model="rangeSelected"
              :options="calculatedListRange"
              :multiple="false"
              :close-on-select="false"
              :clear-on-select="false"
              :searchable="false"
              placeholder="Pilih Rentang Waktu"
              class="mc-video-history-new__modal-download-select-range-list"
            >
              <template #option="{ option }">
                <div class="mc-video-history-new__modal-download-select-range-list__option">
                  <span> {{ momentHms(option.start) }} - {{ momentHms(option.end) }} </span>
                  <div
                    class="mc-video-history-new__modal-download-select-range-list__alert-list-wrapper"
                  >
                    <span
                      v-for="alert in option.rawAlerts"
                      :key="alert.rawAlertId"
                      class="alert-icon-wrapper"
                      :class="{ urgent: alert.isUrgent, important: alert.isImportant }"
                    >
                      <i :class="getAlertIcon(alert.alert.alertCode)" />
                    </span>
                  </div>
                </div>
              </template>
              <template #singleLabel="{ option }">
                <div class="mc-video-history-new__modal-download-select-range-list__option">
                  <span> {{ momentHms(option.start) }} - {{ momentHms(option.end) }} </span>
                  <div
                    class="mc-video-history-new__modal-download-select-range-list__alert-list-wrapper"
                  >
                    <span
                      v-for="alert in option.rawAlerts"
                      :key="alert.rawAlertId"
                      class="alert-icon-wrapper"
                      :class="{ urgent: alert.isUrgent, important: alert.isImportant }"
                    >
                      <i :class="getAlertIcon(alert.alert.alertCode)" />
                    </span>
                  </div>
                </div>
              </template>
            </Multiselect>
          </div>
          <div class="mc-video-history-new__modal-download-field-item-radio-wrapper">
            <McRadioButton
              id="custom"
              key="custom"
              v-model="downloadType"
              name="downloadType"
              initialValue="custom"
              :label="'Custom'"
            />
            <div class="mc-video-history-new__modal-download-timerange-input-wrapper">
              <date-picker
                v-model="range.start"
                type="time"
                format="HH:mm:ss"
                value-type="HH:mm:ss"
                :show-second="true"
                :clearable="true"
                :disabled="downloadType === 'list-range'"
                placeholder="HH:mm:ss"
              />
              <i class="icon-outline_minus" />
              <date-picker
                v-model="range.end"
                type="time"
                format="HH:mm:ss"
                value-type="HH:mm:ss"
                :show-second="true"
                :clearable="true"
                placeholder="HH:mm:ss"
                :disabled="!range.start || downloadType === 'list-range'"
                :disabled-time="disableEndTime"
              />
            </div>
          </div>
        </div>
      </div>
      <!-- <span
        v-if="showEstimatedFileSize"
        class="mc-video-history-new__modal-download-estimate-filesize"
      >
        {{ $t('videoHistory.estimatedSize') }} ≈ {{ estimatedSize }} MB
      </span> -->
    </div>
    <template #modal-footer="{ cancel }">
      <div class="d-flex align-items-center">
        <McButton
          size="md"
          variant="outline-primary"
          icon="mc-fa icon-outline_close"
          class="me-2"
          :text="$t('global.action.cancel')"
          @click="cancel()"
        />
        <McButton
          size="md"
          variant="primary"
          class="me-2 btn-download-all"
          icon="mc-fa icon-outline_download"
          :text="$t('global.action.download')"
          :disabled="btnDownloadDisabled || loadingDownload"
          :loading="loadingDownload"
          @click="handleClickDownload"
        />
      </div>
    </template>
  </b-modal>
</template>
<script>
import McCheckbox from '@/components/McCheckbox'
import McButton from '@/components/McButton'
import { mapGetters, mapState } from 'vuex'
import McRadioButton from '@/components/McRadioButton'
import Multiselect from 'vue-multiselect'
import moment from 'moment'
import { Helper } from '@/mixin/helper'
import { getAlertIcon } from '@/helpers/alert-icon'

moment.locale('id')

export default {
  components: {
    McCheckbox,
    McButton,
    McRadioButton,
    Multiselect,
  },
  mixins: [Helper],
  props: {
    sectionActive: {
      type: String, // timeline | filelist
      required: true,
    },
  },
  data() {
    return {
      isModalOpen: false,
      range: {
        start: null,
        end: null,
      },
      mapModelChannelChecked: {},
      loadingDownload: false,
      downloadType: 'list-range', // list-range | custom
      rangeSelected: null,
      calculatedListRange: [],
      maxMinutesRange: 5,
      isStartSetRangeEndDefault: false,
    }
  },
  computed: {
    ...mapState('videoHistory', ['filelistDownloadSelected', 'rawAlerts', 'videoChannelActive']),
    ...mapGetters('videoHistory', [
      'statusTextActive',
      'deviceTypeActive',
      'markerTimelineDate',
      'normalizedChannels',
      'deviceTimezone',
    ]),
    btnDownloadDisabled() {
      const isChannelChecked =
        Object.keys(this.mapModelChannelChecked).filter((ch) => this.mapModelChannelChecked[ch])
          .length > 0
      if (this.sectionActive === 'timeline') {
        return !this.range.start || !this.range.end || !isChannelChecked
      }
      return (
        (this.downloadType === 'custom' &&
          (!this.range.start || !this.range.end || !isChannelChecked)) ||
        (this.downloadType === 'list-range' && !this.rangeSelected)
      )
    },
    showEstimatedFileSize() {
      return (
        this.range.start &&
        this.range.end &&
        Object.values(this.mapModelChannelChecked).some((ch) => ch)
      )
    },
    rangeDurationInMinutes() {
      const start = this.getTimeInSeconds(this.range.start)
      const end = this.getTimeInSeconds(this.range.end)

      if (start === null || end === null || end < start) {
        return 0
      }

      return (end - start) / 60
    },
    estimatedSize() {
      if (!this.showEstimatedFileSize) return 0

      const estimateVssPerMinute = 530 / 60
      const estimateBsjPerMinute = 6.38
      const durationInMinutes = this.rangeDurationInMinutes

      const channelSelected = Object.values(this.mapModelChannelChecked).filter((ch) => ch).length

      if (this.deviceTypeActive === 'bsj') {
        return (estimateBsjPerMinute * durationInMinutes).toFixed(2) * channelSelected
      }

      if (this.deviceTypeActive === 'vss-howen') {
        return (estimateVssPerMinute * durationInMinutes).toFixed(2) * channelSelected
      }

      return null
    },
    isFromFilelist() {
      return (
        this.filelistDownloadSelected.channel !== null &&
        this.filelistDownloadSelected.startTime !== null &&
        this.filelistDownloadSelected.endTime !== null
      )
    },
  },

  watch: {
    'range.start'() {
      if (this.isStartSetRangeEndDefault) return
      this.range.end = null
    },

    'range.end'(endTime) {
      if (!endTime || this.isEndTimeValid(endTime)) return

      this.range.end = null
    },
  },

  mounted() {
    this.setMapModelChannelChecked()
  },

  methods: {
    resetForm() {
      this.range.start = null
      this.range.end = null
      this.rangeSelected = null
      this.normalizedChannels.forEach((ch) => {
        this.$set(this.mapModelChannelChecked, ch, false)
      })
    },
    setMapModelChannelChecked() {
      this.statusTextActive
        .split(',')
        .map((ch) => {
          let normalized = Number(ch)
          if (this.deviceTypeActive === 'jc') normalized = normalized + 1
          return normalized
        })
        .forEach((ch) => {
          this.$set(this.mapModelChannelChecked, ch, false)
        })
    },
    getTimeInSeconds(time) {
      if (typeof time !== 'string' || !/^\d{2}:\d{2}:\d{2}$/.test(time)) {
        return null
      }

      const [hours, minutes, seconds] = time.split(':').map(Number)

      if (hours > 23 || minutes > 59 || seconds > 59) {
        return null
      }

      return hours * 3600 + minutes * 60 + seconds
    },

    getEndTimeRange() {
      const start = this.getTimeInSeconds(this.range.start)

      if (start === null) return null

      return {
        min: start,
        max: Math.min(start + this.maxMinutesRange * 60, 24 * 60 * 60 - 1),
      }
    },

    disableEndTime(date) {
      const range = this.getEndTimeRange()

      if (!range || !(date instanceof Date) || Number.isNaN(date.getTime())) {
        return true
      }

      const hours = date.getHours()
      const minutes = date.getMinutes()
      const seconds = date.getSeconds()

      const candidate = hours * 3600 + minutes * 60 + seconds
      const candidateMinuteStart = hours * 3600 + minutes * 60
      const candidateMinuteEnd = candidateMinuteStart + 59
      const candidateHourStart = hours * 3600
      const candidateHourEnd = candidateHourStart + 3599

      // Pemeriksaan kandidat jam dari vue2-datepicker.
      if (minutes === 0 && seconds === 0) {
        return candidateHourEnd < range.min || candidateHourStart > range.max
      }

      // Pemeriksaan kandidat menit dari vue2-datepicker.
      if (seconds === 0) {
        return candidateMinuteEnd < range.min || candidateMinuteStart > range.max
      }

      // Pemeriksaan kandidat detik.
      return candidate < range.min || candidate > range.max
    },

    isEndTimeValid(endTime) {
      const range = this.getEndTimeRange()
      const end = this.getTimeInSeconds(endTime)

      return end !== null && range !== null && end >= range.min && end <= range.max
    },

    async handleClickDownload() {
      const channels = Object.keys(this.mapModelChannelChecked)
        .filter((ch) => this.mapModelChannelChecked[ch])
        .map((ch) => Number(ch))

      this.loadingDownload = true

      let rangeStart = this.range.start
      let rangeEnd = this.range.end

      if (this.sectionActive === 'filelist' && this.downloadType === 'list-range') {
        rangeStart = this.momentHms(this.rangeSelected.start)
        rangeEnd = this.momentHms(this.rangeSelected.end)
      }
      console.log(372, rangeStart, rangeEnd)

      await this.$store.dispatch('videoHistory/handleDownloadVideoHistory', {
        channels: channels,
        rangeStart: rangeStart,
        rangeEnd: rangeEnd,
      })

      this.loadingDownload = false

      this.$bvModal.hide('modal-download-video-history')
    },
    onHideModal() {
      this.isModalOpen = false
      this.$store.commit('videoHistory/resetFilelistDownloadSelected')
      this.calculatedListRange = []
      this.resetForm()
    },
    getListRange(startTime, endTime) {
      const start = moment.utc(startTime)
      const end = moment.utc(endTime)

      if (!start.isValid() || !end.isValid() || !end.isAfter(start)) {
        return []
      }

      const ranges = []
      const intervalMinutes = this.maxMinutesRange
      let currentStart = start.clone()

      while (currentStart.isBefore(end)) {
        const currentEnd = moment.min(currentStart.clone().add(intervalMinutes, 'minutes'), end)
        const utcStart = currentStart.toISOString()
        const utcEnd = currentEnd.toISOString()
        ranges.push({
          start: utcStart,
          end: utcEnd,
          rawAlerts: this.rawAlerts.filter((alert) =>
            this.isBetweenDate(alert.createdOn, utcStart, utcEnd)
          ),
        })
        currentStart = currentEnd.clone()
      }

      return ranges
    },
    getAlertIcon(alertCode) {
      return `icon-${getAlertIcon(alertCode)}`
    },
    async onShowModal() {
      this.isModalOpen = true

      await this.$nextTick()
      this.setDefaultValue()
    },
    async setDefaultValue() {
      if (!this.isFromFilelist) {
        this.videoChannelActive.forEach((ch) => {
          this.$set(this.mapModelChannelChecked, ch, true)
        })
        const _start = this.markerTimelineDate
        const _end = moment(this.markerTimelineDate).clone().add(60, 'seconds').toISOString()

        const _startLocal = this.convertUtcToLocalDate(_start, this.deviceTimezone)
        const _endLocal = this.convertUtcToLocalDate(_end, this.deviceTimezone)

        this.isStartSetRangeEndDefault = true
        this.$set(this.range, 'start', _startLocal.split('T')[1])
        this.$set(this.range, 'end', _endLocal.split('T')[1])
        await this.$nextTick()
        this.isStartSetRangeEndDefault = false
      } else {
        this.rangeSelected = null
        this.calculatedListRange = this.getListRange(
          this.filelistDownloadSelected.startTime,
          this.filelistDownloadSelected.endTime
        )
        this.$set(this.mapModelChannelChecked, this.filelistDownloadSelected.channel, true)
      }
    },
  },
}
</script>
